import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import {
    clearApiRegion,
    getUsersApiUrl,
    resolveUsersApiUrl,
} from '../../config';
import { readFromStorage, removeFromStorage } from '../webStorage';
import userAxios from './user.axios';

const axiosConfig: AxiosRequestConfig = {
    baseURL: getUsersApiUrl(),
};
const brokersRolesAxios = axios.create(axiosConfig);

const logout = () => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('user')
    removeFromStorage('role')
    clearApiRegion();
    window.location.reload();
};

// reqeust intercpetor
brokersRolesAxios.interceptors.request.use((config) => {
    const token = readFromStorage('accessToken');
    const requestConfig = {
        ...config,
        baseURL: getUsersApiUrl(),
        url: resolveUsersApiUrl(config.url),
    };

    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...requestConfig,
            headers: {
                ...requestConfig.headers,
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return requestConfig;
});

// Add a response interceptor
brokersRolesAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response?.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const token = readFromStorage('refreshToken');
                    const response = await userAxios.post('/dom/refresh-token', { token });
                    const accessToken = response.data.data.token;
                    localStorage.setItem('accessToken', accessToken);
                    axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
                    return brokersRolesAxios(originalRequest);
                } catch (e) {
                    console.error(e);
                    logout();
                }
            } else {
                logout();
            }
        }
        return Promise.reject(err);
    },
);

export const brokersAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
    }> =>
        async ({ url, method, data }) => {
            const baseUrl = getUsersApiUrl();
            try {
                const result = await brokersRolesAxios({ url: baseUrl + url, method, data });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            }
        };

export default brokersRolesAxios;
